import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    id: null,
    panel_id: 0,
    title: '',
    ord: 0,
};
const slice = createSlice({
    name: 'edit_panel_group_dialog',
    initialState,
    reducers: {
        setupEditPanelGroupDialog(state, action) {
            state.id = action.payload.id;
            state.panel_id = action.payload.panel_id;
            state.title = action.payload.title;
            state.ord = action.payload.ord;
        },
        updateEditPanelGroupDialogTitle(state, action) {
            state.title = action.payload;
        },
        updateEditPanelGroupDialogOrd(state, action) {
            state.ord = action.payload;
        },
    }
});
export const { setupEditPanelGroupDialog, updateEditPanelGroupDialogTitle, updateEditPanelGroupDialogOrd } = slice.actions;
export const edit_panel_group_dialog = slice.reducer;
